import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '284px 1fr',
    width: '100%',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      background: '#F5F6FA',
      gap: 0,
      gridTemplateRows: 'auto 1fr',
    },
  },
  sidebar: {
    width: '100%',
    overflow: 'hidden',
    padding: '0 2px',
  },
  mainWrapper: {
    [theme.breakpoints.down('sm')]: {
      minHeight: '100%',
      background: 'white',
      borderRadius: '16px 16px 0px 0px',
    },
  },
  legal: {
    paddingTop: 16,
    paddingLeft: 32,
  },
  legalContent: {
    color: theme.palette.secondary.dark,
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
  link: {
    marginLeft: '1ch',
  },
}))
